export interface State {
  isCollapsed: boolean;
  isCollapseTransitionDone: boolean;
  isUnCollapseTransitionDone: boolean;
  isUserMenuOpen: boolean;
  isMobileSidebarOpen: boolean;
}

export const module = {
  namespaced: true,
  state: (): State => ({
    isCollapsed: false,
    isCollapseTransitionDone: false,
    isUnCollapseTransitionDone: true,
    isUserMenuOpen: false,
    isMobileSidebarOpen: false,
  }),
  mutations: {
    setCollapsed(state: State, value: boolean) {
      state.isCollapsed = value;
    },
    setCollapseTransitionDone(state: State, value: boolean) {
      state.isCollapseTransitionDone = value;
    },
    setUnCollapseTransitionDone(state: State, value: boolean) {
      state.isUnCollapseTransitionDone = value;
    },
    setUserMenuOpen(state: State, value: boolean) {
      state.isUserMenuOpen = value;
    },
    setMobileSidebarOpen(state: State, value: boolean) {
      state.isMobileSidebarOpen = value;
    },
  },
  actions: {
    toggleSidebar({ commit, state }: { commit: any; state: State }) {
      const newCollapsedState = !state.isCollapsed;
      commit("setCollapsed", newCollapsedState);
      commit("setUserMenuOpen", false);

      if (newCollapsedState) {
        // When collapsing, delay the header centering to wait for text to fade out
        commit("setUnCollapseTransitionDone", false);
        setTimeout(() => {
          commit("setCollapseTransitionDone", true);
        }, 300); // 300ms to match the text fade out timing
      } else {
        // When expanding, immediately center the header
        commit("setCollapseTransitionDone", false);
        setTimeout(() => {
          commit("setUnCollapseTransitionDone", true);
        }, 300); // 300ms to match the text fade out timing
      }
    },
    collapseSidebar({ commit, state }: { commit: any; state: State }) {
      if (state.isCollapsed) return;
      commit("setCollapsed", true);
      commit("setUserMenuOpen", false);
      commit("setUnCollapseTransitionDone", false);
      setTimeout(() => {
        commit("setCollapseTransitionDone", true);
      }, 300);
    },
    expandSidebar({ commit, state }: { commit: any; state: State }) {
      if (!state.isCollapsed) return;
      commit("setCollapsed", false);
      commit("setUserMenuOpen", false);
      commit("setCollapseTransitionDone", false);
      setTimeout(() => {
        commit("setUnCollapseTransitionDone", true);
      }, 300);
    },
    toggleUserMenu({ commit, state }: { commit: any; state: State }) {
      commit("setUserMenuOpen", !state.isUserMenuOpen);
    },
    toggleMobileSidebar({ commit, state }: { commit: any; state: State }) {
      commit("setMobileSidebarOpen", !state.isMobileSidebarOpen);
    },
    closeMobileSidebar({ commit }: { commit: any }) {
      commit("setMobileSidebarOpen", false);
    },
  },
};
